import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** *********************  START GET AUDITING TOOL REPORT DETAILS  ******************** */

export const auditingToolReportGet = (listData: any) => {
	const data = {
		GetAuditingToolToken: listData,
	};
	const url = `${API_URL}PostAllAuditingTool`;
	return makeApiCall(url, data);
};

/** *********************  END GET AUDITING TOOL REPORT DETAILS ******************** */
